import * as React from "react";
import type { SVGProps } from "react";
const SvgUpgradedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M13.44 2.24c-.659 0-1.293.407-1.715 1.067-.015.022-.04.031-.053.053l-6.247 8.575a5.05 5.05 0 0 0-.945 2.957v5.268c0 2.77 2.27 5.04 5.04 5.04h10.64c.849 0 1.55-.343 2.03-.805s.77-1.03.77-1.61c0-.48-.112-.873-.227-1.172.544-.294 1.347-.85 1.347-2.118 0-.798-.387-1.321-.77-1.663.383-.376.77-.93.77-1.767 0-1.256-.796-1.77-1.26-2.013.048-.288.14-.713.14-1.224 0-1.096-1.035-2.127-2.555-2.135h-.018c-1.739-.05-5.939-.053-6.982-.053.186-.418.322-.709.665-1.488.523-1.185 1.072-2.428 1.242-2.905V6.23c.151-.4.368-.796.368-1.418 0-.864-.337-1.537-.787-1.96-.451-.422-.976-.612-1.453-.612m0 1.12c.138 0 .446.094.683.315.236.22.437.547.437 1.137 0 .381-.114.54-.298 1.033v.017c-.111.313-.682 1.648-1.207 2.835s-1.015 2.276-1.015 2.276a.56.56 0 0 0 .508.787s5.952-.002 7.822.053h.017c1.044 0 1.453.66 1.453 1.015 0 .448-.157 1.417-.157 1.417a.56.56 0 0 0 .367.613s.91.293.91 1.207c0 .82-.823 1.313-.823 1.313a.562.562 0 0 0 .053 1.014s.77.283.77 1.103c0 .923-1.155 1.365-1.155 1.365a.56.56 0 0 0-.346.363.56.56 0 0 0 .084.495s.297.402.297 1.067c0 .149-.13.525-.42.805-.291.28-.709.49-1.26.49H9.52c-2.16 0-3.92-1.76-3.92-3.92v-5.267q.001-1.258.735-2.293c.002-.004-.002-.013 0-.018l6.265-8.61q.019-.026.035-.052c.252-.418.59-.56.805-.56"
    />
  </svg>
);
export default SvgUpgradedIcon;
